var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('span',{staticClass:"text-inherit hover:text-primary"},[_vm._v("$ "+_vm._s(parseFloat(_vm.params.value).toFixed(2)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }